module.exports = __webpack_public_path__ + "static/media/share_person9.e4a9c328.png";